import { useDispatch, useSelector } from "react-redux";
import { replace, upperCase } from "lodash";

import { getCompanyOnboarding, getUserAccount, getUserProfile, isActivated, isAuthenticated, isOnboarded, SIGN_OUT, UPDATE_ACCOUNT, UPDATE_COMPANY_ONBOARDING, UPDATE_PROFILE } from "../../states/slices/userAccountSlice";
import { useNavigate } from "react-router-dom";
import { IUser, User } from "../../components/models/User";
import UserAccount, { IUserAccount } from "../../components/models/UserAccount";
import { SIGN_IN } from "../../resources/links";
import { ICompanyOnboarding } from "../../resources/interfaces";

function useUserAccount() {
    const dispatch = useDispatch();
    const PROFILE = useSelector(getUserProfile);
    const ACCOUNT = useSelector(getUserAccount);
    const COMPANY_ONBOARDING = useSelector(getCompanyOnboarding);
    const IS_AUTHENTICATED = useSelector(isAuthenticated);
    const IS_ACTIVATED = useSelector(isActivated);
    const nameInitials = upperCase(PROFILE?.first_name?.charAt(0) + PROFILE?.last_name?.charAt(0)).trim();
    const IS_ONBOARDED = useSelector(isOnboarded);

    const navigate = useNavigate();

    const setProfile = (data: IUser): IUser => {
        dispatch(UPDATE_PROFILE(data));
        return PROFILE;
    }

    const updateProfile = (data: Partial<IUser>): IUser => {
        dispatch(UPDATE_PROFILE(data));
        return PROFILE;
    }

    const getProfile = (): IUser => {
        return PROFILE;
    }

    const getUser = (): User => {
        return new User({
            ...PROFILE
        });
    }

    const setAccount = (data: IUserAccount): IUserAccount => {
        dispatch(UPDATE_ACCOUNT(data));
        return ACCOUNT;
    }

    const updateAccount = (data: Partial<IUserAccount>): IUserAccount => {
        dispatch(UPDATE_ACCOUNT(data));
        return ACCOUNT;
    }

    const getAccount = () => {
        return new UserAccount(ACCOUNT);
    }

    const signOut = async (redirect = true) => {
        dispatch(SIGN_OUT());

        if (redirect) {
            navigate(`/auth/${SIGN_IN}`, { replace: true });
        }
    }

    const updateCompanyOnboarding = (data: ICompanyOnboarding): ICompanyOnboarding => {
        dispatch(UPDATE_COMPANY_ONBOARDING(data));
        return COMPANY_ONBOARDING;
    }

    const user = new User(getProfile());

    return {
        setProfile,
        getProfile,
        getUser,
        updateProfile,
        signOut,
        getAccount,
        updateAccount,
        setAccount,
        IS_AUTHENTICATED,
        nameInitials, 
        user, 
        isAuthenticated, 
        IS_ACTIVATED, 
        IS_ONBOARDED, 
        updateCompanyOnboarding, 
        COMPANY_ONBOARDING
    };
}

export default useUserAccount;